import React from 'react';
import Svg, { ClipPath, Defs, FeBlend, FeColorMatrix, FeComposite, FeFlood, FeOffset, Filter, G, LinearGradient, Path, RadialGradient, Stop } from 'react-native-svg';

const LeaderOneIcon = () => {
  return (
    <Svg width={40} height={40} viewBox="0 0 40 40" fill="none">
      <Defs>
        <Filter
          id="filter0_d_313_839"
          x={1}
          y={1}
          width={38}
          height={39}
          filterUnits="userSpaceOnUse"
        >
          <FeFlood floodOpacity={0} result="BackgroundImageFix" />
          <FeColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <FeOffset dy={1} />
          <FeComposite in2="hardAlpha" operator="out" />
          <FeColorMatrix
            type="matrix"
            values="0 0 0 0 0.300741 0 0 0 0 0.171852 0 0 0 0 0.0192593 0 0 0 1 0"
          />
          <FeBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_313_839"
          />
          <FeBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_313_839"
            result="shape"
          />
        </Filter>

        <LinearGradient
          id="paint0_linear_313_839"
          x1="20.0005"
          y1="40.728"
          x2="20.0005"
          y2="-3.19427"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F07E00" />
          <Stop offset={1} stopColor="#F7F4CF" />
        </LinearGradient>

        <ClipPath id="clip_star">
          <Path d="M19.1935 11.4916C19.5314 10.8361 20.4686 10.8361 20.8065 11.4916L22.953 15.6562C23.0395 15.8239 23.1761 15.9605 23.3438 16.047L27.5084 18.1935C28.1639 18.5314 28.1639 19.4686 27.5084 19.8065L23.3438 21.953C23.1761 22.0395 23.0395 22.1761 22.953 22.3438L20.8065 26.5084C20.4686 27.1639 19.5314 27.1639 19.1935 26.5084L17.047 22.3438C16.9605 22.1761 16.8239 22.0395 16.6562 21.953L12.4916 19.8065C11.8361 19.4686 11.8361 18.5314 12.4916 18.1935L16.6562 16.047C16.8239 15.9605 16.9605 15.8239 17.047 15.6562L19.1935 11.4916Z" />
        </ClipPath>

        <RadialGradient
          id="star_grad"
          cx="20"
          cy="19"
          r="8"
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset="0" stopColor="white" />
          <Stop offset="1" stopColor="#E0E0E0" />
        </RadialGradient>
      </Defs>

      <G filter="url(#filter0_d_313_839)">
        <Path
          d="M24.1708 37.6019C21.6838 39.466 18.3162 39.466 15.8292 37.6019L3.92545 28.6795C1.43848 26.8154 0.397838 23.5112 1.34777 20.4951L5.89462 6.05826C6.84455 3.04209 9.569 1 12.6431 1H27.3569C30.431 1 33.1554 3.0421 34.1054 6.05826L38.6522 20.4951C39.6022 23.5112 38.5615 26.8154 36.0746 28.6795L24.1708 37.6019Z"
          fill="url(#paint0_linear_313_839)"
        />
        <Path
          d="M12.6426 2.5H27.3574C29.7509 2.50021 31.9138 4.09269 32.6748 6.50879L37.2217 20.9453C37.9849 23.3686 37.1404 26.0062 35.1748 27.4795L23.2715 36.4014C21.3177 37.8658 18.6823 37.8658 16.7285 36.4014L4.8252 27.4795C2.85961 26.0062 2.0151 23.3686 2.77832 20.9453L7.3252 6.50879C8.08615 4.09269 10.2491 2.50021 12.6426 2.5Z"
          stroke="white"
          strokeOpacity={0.4}
          strokeWidth={3}
        />
      </G>

      {/* Star Shape with Gradient */}
      <Path
        clipPath="url(#clip_star)"
        d="M19.1935 11.4916C19.5314 10.8361 20.4686 10.8361 20.8065 11.4916L22.953 15.6562C23.0395 15.8239 23.1761 15.9605 23.3438 16.047L27.5084 18.1935C28.1639 18.5314 28.1639 19.4686 27.5084 19.8065L23.3438 21.953C23.1761 22.0395 23.0395 22.1761 22.953 22.3438L20.8065 26.5084C20.4686 27.1639 19.5314 27.1639 19.1935 26.5084L17.047 22.3438C16.9605 22.1761 16.8239 22.0395 16.6562 21.953L12.4916 19.8065C11.8361 19.4686 11.8361 18.5314 12.4916 18.1935L16.6562 16.047C16.8239 15.9605 16.9605 15.8239 17.047 15.6562L19.1935 11.4916Z"
        fill="url(#star_grad)"
      />

      {/* Subtle Inner Stroke */}
      <Path
        d="M18.749 11.2627C19.2731 10.246 20.7269 10.246 21.251 11.2627L23.3975 15.4268C23.4363 15.5021 23.4979 15.5637 23.5732 15.6025L27.7373 17.749C28.754 18.2731 28.754 19.7269 27.7373 20.251L23.5732 22.3975C23.4979 22.4363 23.4363 22.4979 23.3975 22.5732L21.251 26.7373C20.7269 27.754 19.2731 27.754 18.749 26.7373L16.6025 22.5732C16.5637 22.4979 16.5021 22.4363 16.4268 22.3975L12.2627 20.251C11.246 19.7269 11.246 18.2731 12.2627 17.749L16.4268 15.6025C16.5021 15.5637 16.5637 15.5021 16.6025 15.4268L18.749 11.2627Z"
        stroke="black"
        strokeOpacity={0.16}
      />
    </Svg>
  );
};

export default LeaderOneIcon;
